import { push } from 'connected-react-router'
import { refresh } from 'actions/router'
import getSearchByVehicleUrl from 'helpers/getSearchByVehicleUrl'

export const navigateToSearchByVehicle = vehicle => {
  const vehicleUrl = getSearchByVehicleUrl(vehicle)
  return location.pathname !== vehicleUrl ? push(vehicleUrl) : refresh()
}
